import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function getListConfigAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(BASE_URL_API + "user-management/get-list-detail-status", {
    headers: {
      Authorization: token,
    },
  });
}
export async function getSpecificUserStatusAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(BASE_URL_API + "user-management/get-specific-user-status", {
    headers: {
      Authorization: token,
    },
  });
}

export async function createConfigAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API + "user-management/create-detail-status",
    data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
export async function updateConfigAPI(data) {
  const token = await checkTokenExpiration();
  return axios.put(
    BASE_URL_API + `user-management/update-detail-status`,
    data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
export async function markDefaultConfigAPI(data) {
  const token = await checkTokenExpiration();
  return axios.put(
    BASE_URL_API + `user-management/mark-default/${data}`,
    data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
export async function deleteConfigAPI(data) {
  const token = await checkTokenExpiration();
  return axios.delete(
    BASE_URL_API + `user-management/delete-detail-status/${data.id}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
